import React from "react";
import { IconLetter, IconPhoneCall } from "kompare-ui-library";
import logo from "src/assets/images/logo-kompare3.png";
import { i18n, mediaQuery } from "src/common";
import { Button, Divider, Flex, Label, Text, WhatsAppIcon } from 'src/components';
import { colors } from "src/theme";
import styled from "@emotion/styled";
import BaseModal from "./base.modal";

const ButtonContainerFlexStyle = styled(Flex)({
  width: '100%',
  gap: 8,
  flexDirection: 'column',
  [mediaQuery('mobile')]: {
    flexDirection: 'row',
  }
})

const LinkStyle = styled.a({
  width: '100%',
  [mediaQuery('mobile')]: {
    width: 160,
  }
})

const ButtonStyle = styled(Button)({
  width: '100%',
})

const ButtonStyle2 = styled(Button)({
  minWidth: 100,
})

const LogoContainerStyle = styled.div({
  width: 125,
  height: 125,
})

const LogoStyle = styled.img({
  width: '100%',
  height: '100%',
  objectFit: 'contain',
})

const FlexStyle = styled(Flex)({
  maxWidth: 400,
  marginBottom: 48,
  textAlign: 'center',
})

const FlexStyle2 = styled(Flex)({
  marginBottom: 32,
})

const FlexStyle3 = styled(Flex)({
  flexDirection: 'column',
  [mediaQuery('mobile')]: {
    flexDirection: 'row',
  }
})

const LabelStyle = styled(Label)({
  marginBottom: 16,
})

const TextStyle = styled(Text)({
  whiteSpace: 'pre',
  display: 'none',
  [mediaQuery('mobile')]: {
    display: 'block',
  }
})

export interface ContactProps {
  open?: boolean;
  icon?: React.ReactNode;
  onClose?: () => void;
}

export const ContactModal = ({ open = false, icon, onClose }: ContactProps) => (
  <BaseModal open={open} onClose={() => onClose && onClose()}>
    <Flex vertical justify="center" align="center">
      <LogoContainerStyle>
        {!icon ? <LogoStyle src={logo} alt="" /> : icon}
      </LogoContainerStyle>
      <FlexStyle vertical justify="center" align="center">
        <Text type="xxLarge" bold>{i18n.t('components.modals.contactModal.contactText')}</Text>
      </FlexStyle>
      <ButtonContainerFlexStyle justify="center" align="center">
        <LinkStyle href="tel:+38515550666"><ButtonStyle size="large" btnType="primary" iconPosition="left" text={i18n.t('components.modals.contactModal.callButton')}>{<IconPhoneCall width={12} height={12} />}</ButtonStyle></LinkStyle>
        <LinkStyle href="https://wa.me/38515550666" target="_blank" rel="noreferrer"><ButtonStyle size="large" btnType="primary" iconPosition="left" text={i18n.t('components.modals.contactModal.whatsAppButton')}>{<WhatsAppIcon width={12} height={12} />}</ButtonStyle></LinkStyle>
        <LinkStyle href="mailto:szop@kompare.hr"><ButtonStyle size="large" btnType="primary" iconPosition="left" text={i18n.t('components.modals.contactModal.emailButton')}>{<IconLetter width={12} height={12} />}</ButtonStyle></LinkStyle>
      </ButtonContainerFlexStyle>
      <Divider gap={24} dashed />
      <FlexStyle2 vertical justify="center" align="center">
        <LabelStyle type="tiny" bold color={colors.text2}>{i18n.t('components.modals.contactModal.workingHoursLabel')}</LabelStyle>
        <FlexStyle3 justify="center" align="center">
          <Text type="small">{i18n.t('components.modals.contactModal.workingHoursText1')}</Text>
          <TextStyle type="small">{', '}</TextStyle>
          <Text type="small">{i18n.t('components.modals.contactModal.workingHoursText2')}</Text>
        </FlexStyle3>
      </FlexStyle2>
      <Flex vertical justify="center" align="center">
        <ButtonStyle2 onClick={() => onClose && onClose()} size="large" btnType="outlineBlack" text={i18n.t('components.modals.contactModal.closeButton')} />
      </Flex>
    </Flex>
  </BaseModal>
);
